export enum CustomerDataFormFieldsMaxLength {
  CUSTOMER = 50,
  ADDRESS = 255,
  CITY = 128,
  PHONE = 25,
}
